import React, { useState } from "react"
import "./../../CompanysForm.css"
import B3Form from "./B3Form"
import B3Table from "./B3Table"

const B3Grid = ({
  data,
  currentPage,
  setCurrentPage,
  showList,
  setShowList,
  totalPages,
  companySelected,
  setCompanySelected,
}) => {
  return (
    <>
      {showList ? (
        <>
          {!!data.length && (
            <>
              <B3Table
                dataArray={data}
                currentPage={currentPage}
                onPageChange={setCurrentPage}
                setCompanySelected={setCompanySelected}
                setShowList={setShowList}
                totalPages={totalPages}
              />
            </>
          )}
        </>
      ) : (
        <B3Form
          companySelected={companySelected}
          setCompanySelected={setCompanySelected}
          showList={showList}
          setShowList={setShowList}
          setCurrentPage={setCurrentPage}
        />
      )}
    </>
  )
}

export default B3Grid
